import styled from 'styled-components'

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 38px 12px;
  text-align: center;
`

export const EmptyIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.background.secondary};
  margin-bottom: 12px;
`

export const EmptyTitle = styled.h3`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0 0 6px;
`

export const EmptyText = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0 0 12px;
  max-width: 240px;
`

export const NoResults = styled(EmptyStateContainer)``
